// Create-payment routes of the checkout backend (pay-easy-backend-new start/routes.ts). Each ends
// in a random id; change them there, here and in api-payeasy (src/utils/checkoutPaymentPaths.js) together.
export const PAYMENT_PATHS = {
    pix: '/pix-7258fec5-4846-4d86-92c0-a47527b4b3e5',
    boleto: '/boleto-f8ab273b-9668-4906-8aef-3dd148ad24e5',
    picpay: '/picpay-a0df7da0-0bf8-4f13-aeb9-2b2ecbe7b29e',
    pse: '/pse-2158b106-fabe-432b-b149-d65ea259e3bb',
    efecty: '/efecty-6426c424-9f4e-4874-9d4a-6b35ef928182',
    wallet: '/wallet-dd66fa67-ba10-4c3d-88d0-92f93fe14992',
    crypto: '/crypto-b7780a3d-0878-4a10-828d-86caa690f3d0',
    nowpayment_deposit: '/nowpayment_deposit-1f77af49-dce5-4415-9180-a4df7f8347ba',
    paycash: '/paycash-311bab8f-c0f1-40e4-b152-d1daf325b428',
    monnet_payment: '/monnet_payment-c343ec1c-2dd1-4809-b179-924c7387fc5a',
    cobre_payment: '/cobre_payment-9675256a-f4cd-45e3-9e97-06b7178362de',
    prontopaga_payment: '/prontopaga_payment-0aeec4e9-bb98-44c5-92b9-af10f4867906',
    mids88: '/mids88-ca3d65d9-177c-483a-afe6-60adb17f0a5e',
    payok_payment: '/payok_payment-73b8b341-4ae2-410e-8edc-c6c9089bdebd',
    ofapay: '/ofapay-1c40d786-0814-4301-82fb-be38f2dbd267',
    starpago_payment: '/starpago_payment-ccdf0258-d304-44ff-902f-f969c7cc8089',
};
